export default __webpack_public_path__ + "static/media/SJA1370.34I-41602_-24880_0.08f14be5.jpg";